import { Link, useLocation } from "react-router-dom";
import { CalendarDays, FileText, Zap, BarChart3, LayoutDashboard, Users, HardDrive, Shield, History, BookOpen, Archive } from "lucide-react";
import { cn } from "@/lib/utils";

export const AdminNavigation = () => {
  const location = useLocation();
  
  const links = [
    {
      to: "/admin",
      label: "Dashboard",
      icon: LayoutDashboard,
    },
    {
      to: "/admin/kalender",
      label: "Kalender",
      icon: CalendarDays,
    },
    {
      to: "/admin/documents",
      label: "Dokumente",
      icon: FileText,
    },
    {
      to: "/admin/betroffenenrechte",
      label: "Betroffenenrechte",
      icon: Users,
    },
    {
      to: "/admin/backup",
      label: "Backup",
      icon: HardDrive,
    },
    {
      to: "/admin/iso27001",
      label: "ISO 27001",
      icon: Shield,
    },
    {
      to: "/admin/performance",
      label: "Performance",
      icon: Zap,
    },
    {
      to: "/admin/tracking",
      label: "Analytics",
      icon: BarChart3,
    },
    {
      to: "/admin/changelog",
      label: "Changelog",
      icon: History,
    },
    {
      to: "/admin/rechtstexte",
      label: "Rechtstexte",
      icon: Archive,
    },
    {
      to: "/admin/handbuch",
      label: "Handbuch",
      icon: BookOpen,
    },
  ];

  return (
    <div className="max-w-full overflow-x-hidden border-b border-border bg-background/95 backdrop-blur-sm">
      <div className="container mx-auto max-w-full px-4">
        <nav className="flex space-x-1 overflow-x-auto [scrollbar-width:thin]" aria-label="Admin Navigation">
          {links.map((link) => {
            const Icon = link.icon;
            const isActive = location.pathname === link.to;
            
            return (
              <Link
                key={link.to}
                to={link.to}
                className={cn(
                  "flex items-center space-x-2 px-4 py-3 text-sm font-medium transition-colors whitespace-nowrap border-b-2",
                  isActive
                    ? "border-primary text-primary"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:border-border"
                )}
              >
                <Icon className="h-4 w-4" />
                <span>{link.label}</span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};
